import React from 'react';
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";


function Contact() {
  return (
    <> 
    <Helmet>
    <meta charset="utf-8" />
    <title>Contact | Eagle Eye Enterprises</title>
    <link
          rel="canonical"
          href="https://eagleeyeenterprises.co.in/"
        /> 
    <meta name="description" content="Eagle Eye Enterprises CCTV security services CCTV cameras are one of the important elements in securing our businesses and daily lives. We provide design and installation of end-to-end CCTV security systems right from cameras (both analog & IP) to network to NVR's to server/storage to power backup solution to monitoring solution etc. We also provide wireless camera solutions; we have everything you need to customize your business security. We provide Best Performance Surveillance Security Systems at competitive price"/>
    <meta name="keywords" content="eagle eye enterprises EEE, Kankarbhagh, Patna"/>
    </Helmet>
    {/* <!-- Page Header Start -->  background:'cover' */}
    <div className="container-fluid page-contact   py-3 mb-5"  >
  <div className="container py-5">
    <h1 className="display-3 text-white mb-3 animated slideInDown">Contact</h1>
    <nav aria-label="breadcrumb animated slideInDown">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link className="text-white" to="/">Home</Link></li> 
        <li className="breadcrumb-item text-white active" aria-current="page">Contact</li>
      </ol>
    </nav>
  </div>
</div>

    {/* <!-- Page Header End --> */}


     
 <div className="container-fluid bg-light overflow-hidden px-lg-0">
  <div className="container contact px-lg-0">
  <div className="container-xxl py-5">
  <div className="container">
    <div className="row g-4">
      <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.1s" >
        <div className="h-100  p-4 p-xl-5" style={{backgroundImage: 'linear-gradient(to bottom right, #001628,#5eb4f9)'} }>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="btn-square rounded-circle" style={{width: 86, height: 64, background: '#000000'}}>
              <img className="img-fluid" src="assets/img/add.png" alt="Icon"/>
            </div>
            <span className="mb-0  text-white" style={{marginLeft:'18px'}}>Ashok Nagar, Road No-7B, Kankarbhagh, Near Ramdev Mandir, Patna</span>
          </div>
                   </div>
      </div>
      <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.3s">
        <div className="h-100 p-4 p-xl-5" style={{backgroundImage: 'linear-gradient(to bottom right, #001628,#5eb4f9)'} }>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="btn-square rounded-circle" style={{width: 64, height: 64, background: '#000000'}}>
              <img className="img-fluid" src="assets/img/mail.png" alt="Icon" />
            </div>
            <span className="mb-0 text-white" style={{marginRight:'-18px'}}>eagle.eye112002@gmail.com</span>
          </div>
         </div>
      </div>
      <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.5s">
        <div className="h-100 p-4 p-xl-5" style={{backgroundImage: 'linear-gradient(to bottom right, #001628,#5eb4f9)'} }>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="btn-square rounded-circle" style={{width: 64, height: 64, background: '#000000'}}>
              <img className="img-fluid"  src="assets/img/contact.png" alt="Icon"/>
            </div>  
            <span className="mb-0 text-white" style={{marginRight:'57px'}} >+91 99999 00000</span>
          </div>
                  </div>
      </div>
       

    </div>
  </div>
</div>

     <div className="row g-0 mx-lg-0">
      
      <div className="col-lg-12 pe-lg-0" style={{minHeight: 400}}>
        <div className="position-relative h-100">
          <iframe className="position-absolute w-100 h-100" style={{objectFit: 'cover'}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3598.5183964325715!2d85.15001257366843!3d25.587684865982588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed5883eda5e639%3A0xc4ae30fc90ba2d27!2s7%2C%20Main%20Ashok%20Nagar%20Rd%2C%20Kankarbagh%2C%20Patna%2C%20Bihar%20800020!5e0!3m2!1sen!2sin!4v1697356286768!5m2!1sen!2sin" title='map' allowFullScreen aria-hidden="false" tabIndex={0} />
     
        </div>
      </div>
    </div>
  </div>
</div>  


  

    </>
  )
}

export default Contact